var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from 'lodash';
import * as constants from '@adc/constants';
import configment from '@adc/configment';
import wellKnownSymbols from './wellKnownSymbols';
var HTTP_FETCH_FAILURE_CODE = 0;
var ADC_FETCH_USER_AGENT = 'adc/fetch';
export var serializeParams = function (params) {
    return Object.keys(params)
        .map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    })
        .join('&');
};
export var constructUrl = function (url, params) {
    if (params === void 0) { params = {}; }
    if (_.isEmpty(params)) {
        return url;
    }
    if (_.isPlainObject(params))
        params = serializeParams(params);
    return url + "?" + params;
};
export var userAgent = function () {
    return [ADC_FETCH_USER_AGENT, configment.get('APP_NAME', '').replace(/-/g, '_')]
        .filter(Boolean)
        .join('/');
};
export var attemptAutomaticBodySerialization = function (options) {
    if (options.body &&
        typeof options.body === 'object' &&
        options.headers['Content-Type'] === 'application/json') {
        options.body = JSON.stringify(options.body);
        options.headers['Content-Type'] = 'application/json';
    }
};
export var stripNonStandardFetchOptions = function (options) {
    delete options.useProxy;
    delete options.req;
    stripUnwantedHeaders(options.headers);
};
var stripUnwantedHeaders = function (headers) {
    for (var _i = 0, _a = Object.entries(headers); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value === wellKnownSymbols.removeHeader) {
            delete headers[key];
        }
    }
};
export var executeRequest = function (url, options, executeOptions) {
    executeOptions.eventCapture.on('request:start', {
        uri: url,
        body: options.body,
        headers: options.headers,
        xcid: options.headers['x-cid'] || null,
        userId: null,
        httpMethod: options.method,
    });
    var timesTried = 0;
    function doRequest() {
        var plainFetch = function () { return fetch(url, options); };
        timesTried++;
        return plainFetch()
            .catch(function (err) {
            if (timesTried < executeOptions.tries) {
                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        plainFetch().then(resolve).catch(reject);
                    }, executeOptions.retryTimeout);
                });
            }
            throw err;
        })
            .then(function (response) {
            if (response.ok) {
                return executeOptions.parseResponse(response);
            }
            return executeOptions
                .parseResponse(response)
                .then(function (response) {
                if (response.body && typeof response.body === 'object') {
                    ;
                    response.body.url = url;
                    response.body.method =
                        options.method || 'GET';
                }
                throw response;
            });
        })
            .then(function (parsedResponse) {
            executeOptions.eventCapture.on('response:success', {
                statusCode: parsedResponse.status || constants.httpStatusCodes.OK,
                body: parsedResponse.body || {},
                headers: parsedResponse.headers,
            });
            return parsedResponse;
        })
            .catch(function (err) {
            executeOptions.eventCapture.on('response:failure', {
                statusCode: err.status || HTTP_FETCH_FAILURE_CODE,
                body: err.body || {},
                headers: err.headers,
            });
            throw err;
        });
    }
    return doRequest();
};
export var attachMethodHandlers = function (fetchImplementation) {
    return ['get', 'post', 'put', 'patch', 'delete'].forEach(function (method) {
        ;
        fetchImplementation[method] = function (url, opts) {
            return fetchImplementation(url, __assign(__assign({}, opts), { method: method.toUpperCase() }));
        };
    });
};
export var methodFactory = function (fetchImplementation, method) {
    return function (url, opts) {
        return fetchImplementation(url, __assign(__assign({}, opts), { method: method }));
    };
};
var createBoundedFetch = function (instance) {
    instance.__internal = instance.__internal || Object.create(null);
    var boundFetch = instance.bind(instance);
    boundFetch.__internal = instance.__internal;
    attachMethodHandlers(boundFetch);
    return boundFetch;
};
export var boundedFetchFactory = function (fetchImplementation) { return function (serviceKey) {
    var boundFetch = createBoundedFetch(fetchImplementation);
    boundFetch.__internal.host = configment.get(serviceKey);
    return boundFetch;
}; };
//# sourceMappingURL=common.js.map